import React from 'react';
import classNames from 'classnames';

export default function CloseIcon({ className = '' }) {
	return <span className={classNames('icon icon-close', className)} />;
}
